import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/nami-walks")({
  beforeLoad: () => {
    throw redirect({ to: "/namiwalks" });
  },
});
